var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 16,
    viewBox: "0 0 29 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5501 6.98593C14.44 6.8079 14.298 6.64517 14.1242 6.50659C11.1843 4.16287 7.90143 2.31553 4.39857 1.03375L3.75775 0.799253C2.562 0.361697 1.29797 1.19524 1.13595 2.46804C0.672781 6.10675 0.672781 9.89493 1.13595 13.5336C1.29797 14.8064 2.562 15.64 3.75775 15.2024L4.39857 14.9679C7.90143 13.6861 11.1843 11.8388 14.1242 9.49508C14.298 9.3565 14.44 9.19377 14.5501 9.01574C14.5846 10.5331 14.6966 12.0458 14.886 13.5336C15.048 14.8064 16.312 15.64 17.5077 15.2024L18.1486 14.9679C21.6514 13.6861 24.9343 11.8388 27.8742 9.49508C28.8229 8.73872 28.8229 7.26296 27.8742 6.50659C24.9343 4.16287 21.6514 2.31553 18.1486 1.03375L17.5077 0.799253C16.312 0.361697 15.048 1.19524 14.886 2.46804C14.6966 3.95583 14.5846 5.4686 14.5501 6.98593Z",
    fill: "#A7A7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardIcon);
export default __webpack_public_path__ + "static/media/ForwardIcon.86cf4859481716492d5a07284234ea79.svg";
export { ForwardRef as ReactComponent };